(function() {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ModalAboutCtrl', ModalAboutCtrl);

    ModalAboutCtrl.$inject = ['$scope', '$modalInstance', 'appConfig'];

    /**
     * Controller for a confirmation dialog.
     */
    function ModalAboutCtrl($scope, $modalInstance, appConfig) {
        /**
         * Closes the dialog with an negative (Cancel) choice.
         */
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        $scope.isPatientApp = (appConfig.app === 'patient');
    }
})();